import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducersCropFields(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_producers_crop_fields/${harvested_batch_id}`
    );
  },
  fetchCurrencies(organization_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_currencies`
    );
  },
  fetchPackingLines(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_packing_lines/${harvested_batch_id}`
    );
  },
  fetchExporterProcessCropCategories(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_exporter_process_crop_categories/${harvested_batch_id}`
    )
  },
  fetchExporterProcessCropVarieties(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_exporter_process_crop_varieties/${harvested_batch_id}`
    )
  },
  fetchExporterProcessCropSizes(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_exporter_process_crop_sizes/${harvested_batch_id}`
    )
  },
  fetchExporterProcessCropPackages(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_exporter_process_crop_packages/${harvested_batch_id}`
    )
  },
  fetchExporterProcessBrands(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_exporter_process_brands/${harvested_batch_id}`
    )
  },
  fetchPackingHouseProcesses(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_packing_house_processes/${harvested_batch_id}`
    )
  },
  fetchOrganizationCropField(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_organization_crop_field/${crop_field_id}`
    );
  },
  fetchCropFieldCertifications(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/process/packing/queries_to_package/${organization_id}/fetch_crop_field_certifications/${crop_field_id}`
    );
  },
};
